import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 6,
  title: "Basic Carbon Filters Don't Work in Hot, Fast-Moving Shower Water (Which Is Why the Bunnings Filter Didn't Help)",
  mechanism: <>
      You might have tried a basic shower filter from Bunnings, Kmart, or a
      hardware store. These use activated carbon, which relies on absorption—a{' '}
      <strong data-id="element-169">slow process</strong> requiring time and low temperature. Shower
      water is hot and moves through in seconds. Chlorine, being volatile,{' '}
      <strong data-id="element-170">escapes as gas</strong> before it can be absorbed. These filters
      show 20-40% reduction under lab conditions (slow, cold water) but{' '}
      <strong data-id="element-171">nearly 0%</strong> in actual shower use (hot, fast water). This
      isn't a product failure—it's a <strong data-id="element-172">mechanism mismatch</strong>.
    </>,
  avatars: {
    jessica: <>
        The cheap filter you tried didn't work because its mechanism{' '}
        <strong data-id="element-173">couldn't handle</strong> the water temperature and flow rate.
        You weren't doing it wrong—the{' '}
        <strong data-id="element-174">approach was insufficient</strong>.
      </>,
    michelle: <>
        This is why <strong data-id="element-175">mechanism matters more than price</strong>. A $20
        filter that doesn't work is worse than an $80 filter that{' '}
        <strong data-id="element-176">does</strong>.
      </>
  },
  bridge: <>
      This isn't about creams vs. filters—creams{' '}
      <strong data-id="element-177">can't address the source</strong> (water) at all. This is about
      creams + untreated water vs. creams + <strong data-id="element-178">treated water</strong>.
    </>,
  image: {
    url: 'https://images.unsplash.com/photo-1581093458791-9d42e3c2fd45?w=800&q=80',
    alt: 'Comparison diagram showing water flow through cheap carbon filter (with escaping chlorine gas) versus multi-stage filter (capturing chlorine), illustrating filter mechanism difference'
  },
  imageOnLeft: true,
  bgColor: 'bg-brand-cream',
  borderBottom: 'border-b-2 border-brand-gold'
};
export function Item6Section() {
  return <ItemSection data={data} data-id="element-179" />;
}